import script from "./Autorization.vue?vue&type=script&setup=true&lang=js"
export * from "./Autorization.vue?vue&type=script&setup=true&lang=js"

import "./Autorization.vue?vue&type=style&index=0&id=ebfb593a&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebfb593a"]])

export default __exports__